import React, { useEffect, useState } from "react";
import axios from "axios";
import serverConfig from "../config";
import "./Home.css";
import "./VirtualResource.css";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";
function VirtualResource() {
  const [contentVirtualResource, setContentVirtualResource] = useState(null);

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_virtual_resource`)
      .then((response) => {
        const data = response.data;
        setContentVirtualResource(data);
      })
      .catch((error) => {
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  const [selectedResource, setSelectedResource] = useState(null);
  const [typeResource, seTypeResource] = useState(null);
  const handleResourceSelect = (resource, type) => {
    let newResourceLink = "";

    if (type === "video") {
      newResourceLink = `${serverConfig.serverUrl}/video/virtual_resource/${resource}`;
      if (newResourceLink !== selectedResource) {
        setSelectedResource(newResourceLink);
        seTypeResource("video");
      }
    } else if (type === "file") {
      newResourceLink = `${serverConfig.serverUrl}/file/virtual_resource/${resource}`;
      if (newResourceLink !== selectedResource) {
        setSelectedResource(newResourceLink);
        seTypeResource("file");
      }
    }

    if (type === null && resource === null) {
      setSelectedResource(null);
      seTypeResource(null);
    }
  };

  const componentsVirtualResource = (
    <>
      {contentVirtualResource &&
        Object.keys(contentVirtualResource)
          .sort((a, b) => b - a) // Order in descending order
          .map((order) => (
            <div key={order}>
              {Object.keys(contentVirtualResource[order]).map((category) => (
                <div key={category}>
                  <h3
                    style={{
                      color: "#003366",
                      backgroundColor: "#F5F7FA",
                      padding: "10px",
                      borderRadius: "10px",
                      margin: "5px",
                      border: "2px solid #D8DEE9",
                      textAlign: "center",
                    }}
                  >
                    <strong>{category}</strong>
                  </h3>
                  {contentVirtualResource[order][category]
                    .sort((a, b) => a.internal_order - b.internal_order) // Order in ascending order
                    .map((item, index) => (
                      <div
                        key={index}
                        className="video-link"
                        //onClick={() => handleVideoSelect(item.link_video)}
                        onClick={() => {
                          if (item.link_video) {
                            handleResourceSelect(item.link_video, "video");
                          } else if (item.file) {
                            handleResourceSelect(item.file, "file");
                          }
                        }}
                        style={{
                          backgroundColor:
                            selectedResource &&
                            selectedResource.endsWith(
                              item.link_video || item.file
                            )
                              ? "#003366"
                              : "white",
                          color:
                            selectedResource &&
                            selectedResource.endsWith(
                              item.link_video || item.file
                            )
                              ? "white"
                              : "#003366",
                          padding: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {item.name}
                      </div>
                    ))}
                </div>
              ))}
            </div>
          ))}
    </>
  );

  const componentsVideo = (
    <>
      {selectedResource && (
        <div>
          <div>
            <button
              style={{
                backgroundColor: "darkred",
                color: "white",
                borderRadius: "10px",
                border: "3px solid darkred",
              }}
              //onClick={() => setSelectedVideo(null)}
              onClick={() => handleResourceSelect(null, null)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-x-circle"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
            </button>
          </div>

          {typeResource === "video" ? (
            <div className="video-container">
              <video controls key={selectedResource}>
                <source src={selectedResource} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            <div style={{ height: "100vh", padding: "20px" }}>
              <iframe
                title="pdf-preview"
                src={`${serverConfig.serverUrl}/file/regulation/regolamentoDSM.pdf#toolbar=0`}
                width="100%"
                height="100%"
              />
            </div>
          )}
        </div>
      )}
    </>
  );
/*
  const viewVirtualResources = (
    <>
      {selectedResource ? (
        <div className="row">
          <div className="col-3">{componentsVirtualResource}</div>
          <div className="col-9">{componentsVideo}</div>
        </div>
      ) : (
        <div className="row">{componentsVirtualResource}</div>
      )}
    </>
  );
  */

  const viewVirtualResources = (
    <>
      {selectedResource ? (
        <div className="row">
<div className="col-3 virtual-resource-list">{componentsVirtualResource}</div>
<div className="col-9">{componentsVideo}</div>
        </div>
      ) : (
        <div className="row">{componentsVirtualResource}</div>
      )}
    </>
  );

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>{viewVirtualResources}</div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {viewVirtualResources}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default VirtualResource;
